"use strict";

exports.__esModule = true;
exports.AgendaDevicesField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Core = require("../../Core");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector");
var _dec, _class, _AgendaDevicesField;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var validate = function validate(input) {
  if (!input || input.length === 0) {
    return "Select at least one device to edit the agenda.";
  }
};
var AgendaDevicesField = exports.AgendaDevicesField = (_dec = _DeviceListContext.DeviceListContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (_AgendaDevicesField = /*#__PURE__*/function (_Component) {
  function AgendaDevicesField() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(AgendaDevicesField, _Component);
  var _proto = AgendaDevicesField.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      prefix = _this$props.prefix,
      devices = _this$props.devices,
      translate = _this$props.translator.translate;
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
      name: prefix + ".devices",
      validate: validate
    }, function (_ref) {
      var input = _ref.input,
        meta = _ref.meta;
      return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        intent: meta.error ? "danger" : "secondary",
        helperText: meta.error ? meta.error : translate("AgendaDevicesField.devices.helperText", "The devices for this agenda."),
        label: translate("AgendaDevicesField.devices.label", "Devices"),
        labelFor: prefix + ".devices",
        requiredLabel: "*"
      }, /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
        style: {
          maxWidth: 500
        },
        devices: devices,
        tags: [],
        selectAllByDefault: true,
        selected: input.value || [],
        onSelect: function onSelect(selected) {
          return input.onChange(selected.map(function (device) {
            return typeof device === "string" ? device : device.uuid;
          }));
        }
      }));
    });
  };
  return AgendaDevicesField;
}(_react.Component), _AgendaDevicesField.defaultProps = {
  translator: undefined,
  devices: undefined
}, _AgendaDevicesField)) || _class) || _class);